//
// Preload JS
// --------------------------------------------------
// Removes preload class to enable transitions - removes style attribute from body to reduce FUOC

window.addEventListener('load', event => {
    document.body.classList.remove('preload');
    document.body.removeAttribute('style');
});